export { JobDetailsAndApplicationsList } from './JobDetailsAndApplicationsList';
